import { render } from "./LabelShapes.vue?vue&type=template&id=58a6b35a&scoped=true&ts=true"
import script from "./LabelShapes.vue?vue&type=script&lang=ts"
export * from "./LabelShapes.vue?vue&type=script&lang=ts"

import "./LabelShapes.vue?vue&type=style&index=0&id=58a6b35a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a6b35a"]])

export default __exports__